'use client';

import React from 'react';
import Link from 'next/link';
import { Bitcoin, Settings } from 'lucide-react';
import AppLogo from '@/components/ui/AppLogo';

export default function DataPageHeader() {
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="flex items-center justify-between h-16">
          {/* Left: Logo + Title */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2.5">
              <AppLogo size={32} />
              <span className="font-bold text-lg tracking-tight text-gray-900 hidden sm:block">
                Spine
              </span>
            </div>
            <div className="hidden md:block w-px h-6 bg-gray-200" />
            <div className="hidden md:flex flex-col">
              <span className="text-sm font-semibold text-gray-900 leading-tight">Bitcoin-Backed Yield Curve

              </span>
              <span className="text-xs text-gray-400 leading-tight">
                Fixed-Rate Credit Market Simulator
              </span>
            </div>
          </div>

          {/* Center: BTC badge */}
          <div className="hidden lg:flex items-center gap-2 bg-[#FFF7ED] border border-orange-200 rounded-full px-4 py-1.5">
            <Bitcoin size={14} className="text-orange-500" />
            <span className="text-xs font-semibold text-orange-700">BTC Collateral</span>
            <span className="text-xs text-orange-400">·</span>
            <span className="text-xs text-orange-600 font-mono">LTV/Liq. LTV - 80/83%</span>
          </div>

          {/* Right: Edit link */}
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-1.5 bg-[#EEE9FF] rounded-full px-3 py-1.5">
              <span className="w-2 h-2 rounded-full bg-[#6C47FF] animate-pulse inline-block" />
              <span className="text-xs font-semibold text-[#6C47FF]">Live View</span>
            </div>
            <Link
              href="/yield-curve-simulator/edit"
              className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6C47FF] bg-white border border-gray-200 rounded-lg px-3 py-2 hover:border-[#6C47FF]/30 hover:bg-[#EEE9FF] transition-all duration-150 active:scale-95">

              <Settings size={14} />
              <span className="hidden sm:inline font-medium">Edit Curve</span>
            </Link>
          </div>
        </div>
      </div>
    </header>);

}